export const navbar = [
  {
    title: "Bộ sưu tập",
    path: "/Bo-suu-tap",
    menu: [
      {
        title: "Mùa đông 2021",
        path: "/Bo-suu-tap/Mua-dong-2021",
      },
      {
        title: "Tết Canh Dần 2022",
        path: "/Bo-suu-tap/Tet-Canh-Dan-2022",
      },
    ],
  },
  {
    title: "Áo",
    path: "/Ao",
    menu: [
      {
        title: "Áo thun | T-shirt",
        path: "/Ao/Ao-thun",
      },
      {
        title: "Áo khoác | Jacket",
        path: "/Ao/Ao-khoac",
      },
      {
        title: "Sơ mi | Shirt",
        path: "/Ao/So-mi",
      },
      {
        title: "Áo trùm đầu | Hoodie",
        path: "/Ao/Ao-trum-dau",
      },
      {
        title: "Áo tay dài | Sweater",
        path: "/Ao/Ao-tay-dai",
      },
    ],
  },
  {
    title: "Quần",
    path: "/Quan",
    menu: [
      {
        title: "Quần dài | Pants",
        path: "/Quan/Quan-dai",
      },
      {
        title: "Quần ngắn | Shorts",
        path: "/Quan/Quan-ngan",
      },
    ],
  },
  {
    title: "Phụ kiện",
    path: "/Phu-kien",
    menu: [
      {
        title: "Ba lô | Backpacks",
        path: "/Phu-kien/Ba-lo",
      },
      {
        title: "Túi | Bag",
        path: "/Phu-kien/Tui",
      },
      {
        title: "Ví | Wallet",
        path: "/Phu-kien/Vi",
      },
      {
        title: "Nón | Cap",
        path: "/Phu-kien/Non",
      },
    ],
  },
  {
    title: "Blog",
    path: "/Blog",
    menu: [],
  },
  {
    title: "Liên hệ",
    path: "/Lien-he",
    menu: [],
  },
];
